"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kBleedingRiskMale = exports.kBleedingRiskComplicatedUlcer = exports.kBleedingRiskUlcer = exports.kBleedingRiskDyspepsia = exports.kBleedingRiskCoagulant = exports.kBleedingRiskPrednisone = exports.kBleedingRiskNSAID = exports.kBleedingRiskAge = void 0;
exports.kBleedingRiskAge = "bleedingRiskAge";
exports.kBleedingRiskNSAID = "bleedingRiskNSIAID";
exports.kBleedingRiskPrednisone = "bleedingRiskPrednisone";
exports.kBleedingRiskCoagulant = "bleedingRiskCoagulant";
exports.kBleedingRiskDyspepsia = "bleedingRiskDyspepsia";
exports.kBleedingRiskUlcer = "bleedingRiskUlcer";
exports.kBleedingRiskComplicatedUlcer = "bleedingRiskComplicatedUlcer";
exports.kBleedingRiskMale = "bleedingRiskMale";
//# sourceMappingURL=BleedingRisk.js.map


/** WEBPACK FOOTER **
 ** ./src/models/BleedingRisk.js
 **/